import request from '@/plugins/axios'

//获取征稿活动列表
export function listPictureActivityArticle(params) {
    return request({
        url: '/pictureActivityArticle/listPictureActivityArticle',
        method: 'get',
        params
    })
}
//获取征稿活动列表
export function listPictureActivityArticles(params) {
    return request({
        url: '/pictureActivityArticle/listPictureActivityArticles',
        method: 'get',
        params
    })
}
//获取稿件最新一条审核信息
export function articleWorkflow(params) {
    return request({
        url: '/pictureActivityArticle/articleWorkflow',
        method: 'get',
        params
    })
}

//添加征稿活动
export function addPictureActivityArticle(data) {
    return request({
        url: '/pictureActivityArticle/addPictureActivityArticle',
        method: 'post',
        data
    })
}

//删除征稿活动
export function deletePictureActivityArticle(params) {
    return request({
        url: '/pictureActivityArticle/deletePictureActivityArticle/' + params,
        method: 'get'
    })
}

//查询单个征稿活动
export function getPictureActivityArticle(params) {
    return request({
        url: '/pictureActivityArticle/getPictureActivityArticle/' + params,
        method: 'get'
    })
}

//修改征稿活动信息
export function updatePictureActivityArticle(data) {
    return request({
        url: '/pictureActivityArticle/updatePictureActivityArticle',
        method: 'post',
        data
    })
}



//设置审核结果
export function setCheck(params) {
    return request({
        url: '/pictureActivityArticle/setCheck',
        method: 'post',
        params
    })
}

//设置稿件状态
export function setStatus(params) {
    return request({
        url: '/pictureActivityArticle/setStatus',
        method: 'post',
        params
    })
}
//获取投稿总图片数
export function articlePicturesNumbers(params) {
    return request({
        url: '/pictureActivityArticle/articlePicturesNumbers',
        method: 'get',
        params
    })
}


//批量修改投稿信息
export function batchUpdatePictureActivityArticle(data) {
    return request({
        url: '/pictureActivityArticle/batchUpdatePictureActivityArticle',
        method: 'post',
        data
    })
}